import { createContext, FC, useState, useContext } from 'react';
import { layoutVariant, PageContextProperties, BackPage } from '@sleepunique/types/page-types';
import { PageId } from '@sleepunique/types/view-id-type';

export const PageContext = createContext<PageContextProperties>({
  layoutVariant: 'a',
  setLayoutVariant: () => {},
  isResultsPage: false,
  setIsResultsPage: () => {},
  page: PageId.start,
  setPage: () => {},
  showNavigation: false,
  setShowNavigation: () => {},
  backPage: { override: false, backPageId: null, questionName: '', newSleeperId: 0 },
  setBackPage: () => {},
});

const { Provider } = PageContext;

export const PageProvider: FC = ({ children }) => {
  const [layoutVariant, setLayoutVariant] = useState<layoutVariant>('a');
  const [isResultsPage, setIsResultsPage] = useState<boolean>(false);
  const [page, setPage] = useState<PageId>(PageId.start);
  const [backPage, setBackPage] = useState<BackPage>({
    override: false,
    backPageId: null,
    newSleeperId: 0,
    questionName: '',
  });

  const [showNavigation, setShowNavigation] = useState<boolean>(false);
  const value: PageContextProperties = {
    layoutVariant,
    setLayoutVariant,
    isResultsPage,
    setIsResultsPage,
    page,
    setPage,
    showNavigation,
    setShowNavigation,
    backPage,
    setBackPage,
  };

  return <Provider value={value}>{children}</Provider>;
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) throw Error('usePageContext should be used within an PageProvider');
  return context;
};
